import {gql} from "@apollo/client";
import {ClientFamilyConcernInput} from "../../domain";
import {getDomainGraphqlError, useMutation$} from "graphqlsupport";
import {useCallback} from "react";
import {showToast} from "common";


const GRAPHQL_MUTATION = gql`
mutation submitAuthClientFamilyConcern($input: ClientFamilyConcernInput) {
    submitAuthClientFamilyConcern(input: $input) {
        guid
    }
}`;

type AuthClientFamilyConcernInput = ClientFamilyConcernInput & {
    authorizationGuid: string;
}

export function useAuthClientFamilyConcern(authorizationGuid: string) {
    const {execute,} = useMutation$<{ input: AuthClientFamilyConcernInput }, void>(GRAPHQL_MUTATION);
    const submitClientFamilyConcern = useCallback(async function (formValues: ClientFamilyConcernInput | null) {
        if (formValues == null) {
            return;
        }

        try {
            await execute({
                variables: {
                    input: {
                        ...formValues,
                        authorizationGuid,
                    },
                }
            });
            showToast.success(
                'Client/Family concern request successfully submitted. The Request can be tracked in the "Submitted Requests" section and a request number ID will be available shortly.'
            );
        } catch (errors: any) {
            if (getDomainGraphqlError(errors)) {
                showToast.error(getDomainGraphqlError(errors));
            } else {
                showToast.error(`Unable to submit reason by ${errors.message || errors[0].message}`);
            }
        }
    }, [authorizationGuid, execute]);

    return {
        submitClientFamilyConcern
    }
}
